<div class="form-builder">
    <h2 class="popup-title text-center">{{ selectedMember && selectedMember['id'] ?
        ('managemember.header2popuptitleupdate' | translate) : ('managemember.header2popuptitleadd' | translate) }}
    </h2>
    <div *ngIf="orgUsers.length > 0">
        <app-form-builder [formSchema]="formSchema" (onSubmit)="memberData($event)"></app-form-builder>
    </div>
</div>